import * as React from "react";
import {CSSProperties} from "react";
import User from "../../../model/user/User";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import SearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/SearchDropDown";
import UserInitials from "../common/userInitials/UserInitials";
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import WorkspaceFilter, {WorkspaceFilterReduxProps} from "./WorkspaceFilter";

class AssigneesFilter extends WorkspaceFilter<User> {
	renderContent(items: User[]): JSX.Element {
		return (
			<SearchDropDown multi
							itemRowRenderer={this.renderOption}
							items={items}
							itemToId={(user: User) => user.id}
							selectedItemId={this.getSelectedItems().map(u => u.id)}
							onChange={this.onChange}
							itemToLabel={(user: User) => user.getDisplayName()}
							prependSearchInputIcon={Icon.Search}
							placeholder={"Contains..."}
							optionInlineStyle={{padding: "12px"}}
							componentBetweenInputAndList={this.getNegationCheckbox()}/>
		)
	}

	renderOption(user: User, isSelected: boolean) {
		const style: CSSProperties = {
			textOverflow: "ellipsis",
			overflow: "hidden",
			width: `calc( 100% - ${isSelected ? 90 : 40}px )`
		};
		return (
			<div style={{display: "flex", alignItems: "center"}}>
				<UserInitials user={user}/>
				<div style={style}>{user.getDisplayName(true)}</div>
				{isSelected && <IconLarge icon={Icon.CheckMark}/>}
			</div>
		)
	}

	itemToId(item: User): string {
		return item.id;
	}

	itemToLabel(item: User): string {
		return item.getDisplayName();
	}
}


function mapStateToProps(state: RootState) {
	return {
		items: state.user.users
	}
}

export default connect<WorkspaceFilterReduxProps<User>>(mapStateToProps)(AssigneesFilter)